<template>
  <!-- NOTE: прозрачность и z-index для того чтобы в HeroSection картинка попадала под чипы -->
  <v-card
    elevation="0"
    color="transparent"
    style="z-index: 10"
    tile
  >
    <v-container class="py-3 px-0">
      <ChipsBar
        :model-value="value"
        :items="items"
      />
    </v-container>
    <v-divider v-if="underline" />
  </v-card>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  value: { type: Number, required: true },
  years: { type: Array as PropType<number[]>, required: true },
  underline: { type: Boolean, default: true },
})

const $route = useRoute()
const items = computed(() => props.years.map(year => ({
  text: `${year} год`,
  value: year,
  to: { params: { ...$route.params, year } },
})))
</script>
